import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import '@resources/css/leaflet.rrose.css';
import '@resources/css/theme/imo/leaflet-map.css';
import '@resources/js/app/composables/leaflet/leaflet.patches.js';
import '@resources/js/app/composables/leaflet/leaflet.activearea.js';
import pin from '@resources/svg/marker-cyan-fill.svg';

let self = null;

export default $wire => ({
    map: null,
    projects: null,
    markersGroup: null,
    markerIcon: null,

    async init() {
        self = this;

        let _top = 0;
        let _left = 0;
        let _right = 0;
        let _height = 360;

        if (window.innerWidth > 991) {
            let contactWp = document.querySelector('.contact_wrapper');
            if (contactWp) {
                _left = Math.round(contactWp.offsetLeft + contactWp.offsetWidth);
                _right = Math.round(contactWp.offsetLeft);
            }
        }

        self.map = L.map('developer_map_container', {
            zoomControl: false,
        })
            .setView($wire.center, 13)
            .setActiveArea({
                position: 'absolute',
                top: _top + 'px',
                left: _left + 'px',
                right: _right + 'px',
                height: _height + 'px',
            })
            .setMaxBounds([
                [$wire.bounds[1], $wire.bounds[0] * 0.3],
                [$wire.bounds[3], $wire.bounds[2] * 1.3],
            ]);

        L.tileLayer($wire.mapUrl, {
            subdomains: $wire.subdomains,
            detectRetina: false,
            minZoom: 7,
        }).addTo(self.map);

        L.control
            .zoom({
                position: 'topright',
            })
            .addTo(self.map);

        self.markersGroup = new L.FeatureGroup();
        self.map.addLayer(self.markersGroup);

        self.projects = await $wire.getProjectsData();

        const icon = L.icon({
            iconUrl: pin,
            iconSize: [28, 32],
            iconAnchor: [14, 32],
        });

        if (!self.projects?.length) {
            return false;
        }

        self.projects.every(v => {
            if (!v.geo_location?.length) {
                return false;
            }
            const tooltipContent =
                `<div class='flex flex-row items-center gap-2'>
                <div class='flex items-center w-10 h-10'>
                    <img class='object-cover w-full h-full' alt='project_cover' src='` +
                v.cover_image +
                `'>
                </div>
                
                <div class='flex flex-col gap-y-.5 text-[10px]'>
                    <span class='text-secondary max-w-[200px] text-ellipsis overflow-hidden'>` +
                v.name +
                `</span>
                    <span class='text-grey-500' x-show=` +
                !!v.price_from +
                `>` +
                v.translations.price_from +
                ` ` +
                `<span class='font-semibold'>` +
                v.price_from +
                `</span>` +
                `</span>
                </div>
            </div>`;

            const marker = L.marker(new L.LatLng(...v.geo_location), { icon }).bindTooltip(tooltipContent, {
                direction: 'top',
                opacity: 1,
                offset: L.point({ x: 0, y: -35 }),
            });

            self.markersGroup.addLayer(marker);
            return true;
        });

        const bounds = self.markersGroup?.getBounds();
        if (bounds.isValid()) {
            self.map.fitBounds(bounds);
        }
    },
});
